import { Spinner } from '@nextui-org/react'

export function SpinnerLoader() {
  return (
    <div className="absolute left-0 top-0 z-30 flex h-full w-full items-center justify-center bg-white/50">
      <Spinner />
    </div>
  )
}

export default SpinnerLoader
